import { useMemo, useState, useCallback } from "react";
import { FCX, cssX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { iSearchResultsSection } from "@models/SearchResults";
import { ID } from "@models";
import SearchResultSectionList from "./SearchResultSectionList";

interface SearchResultsSectionsProps {
    sections?: iSearchResultsSection[];
    search: string;
}

const SearchResultsSections: FCX<SearchResultsSectionsProps> = ({
    sections = [],
    search,
}) => {
    const [expandedSectionId, setExpandedSectionId] = useState<ID | null>(null);

    const visibleSections = useMemo(
        () => (
            sections.filter(section => (
                expandedSectionId ? section.id === expandedSectionId : true
            ))
        ),
        [sections, expandedSectionId]
    );

    const handleMoreResultsClick = useCallback(
        (sectionId: ID) => {
            setExpandedSectionId(expandedSectionId === sectionId ? null : sectionId);
        },
        [expandedSectionId]
    );

    const initialColumnsPerSection = useMemo(() => {
        const sectionCount = sections.length;
        if (sectionCount === 1) return 4;
        if (sectionCount === 2) return 2;
        return 1;
    }, [sections.length]);

    if (!sections.length) return null

    return (
        <div
            className={cn(cssX("Dropdown"), "ToolSearch__results", "appears-top", "fast")}
            data-testid="blockToolSearchResultsSections"
        >
            {visibleSections.map((section, sectionIndex) => (
                <div
                    className={cn(
                        cssX("Dropdown__column"),
                        "appears-left",
                        `del-${sectionIndex + 1}`
                    )}
                    key={section.id}
                >
                    <div className="ToolSearch__resultsSectionTitle">
                        {section.title}
                    </div>
                    <SearchResultSectionList
                        sectionId={section.id}
                        list={section.items}
                        search={search}
                        isOpened={expandedSectionId === section.id}
                        onMoreResultsClick={() => handleMoreResultsClick(section.id)}
                        initialColumnsPerSection={initialColumnsPerSection}
                    />
                </div>
            ))}
        </div>
    );
};

export default SearchResultsSections;
